var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVividLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 21,
    viewBox: "0 0 62 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2004 20.0382H7.21949L0 1.10692H4.53317L9.70993 15.6672L14.8587 1.10692H19.3919L12.2004 20.0382Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6545 4.31416C21.5072 4.31416 20.5278 3.34915 20.5278 2.15708C20.5278 0.965009 21.5072 0 22.6545 0C23.8297 0 24.7811 0.965009 24.7811 2.15708C24.7811 3.34915 23.8297 4.31416 22.6545 4.31416ZM24.4453 20.0382H20.8916V6.32933H24.4453V20.0382Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1607 20.0382H31.3271L25.8985 6.32933H29.7041L33.2299 15.8659L36.7557 6.32933H40.5893L35.1607 20.0382Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7987 4.31416C42.6515 4.31416 41.6721 3.34915 41.6721 2.15708C41.6721 0.965009 42.6515 0 43.7987 0C44.974 0 45.9254 0.965009 45.9254 2.15708C45.9254 3.34915 44.974 4.31416 43.7987 4.31416ZM45.5896 20.0382H42.0358V6.32933H45.5896V20.0382Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8455 20.0382H58.2637V18.3068C57.2004 19.6408 55.7173 20.3787 54.0943 20.3787C50.6805 20.3787 48.1061 17.7675 48.1061 13.1979C48.1061 8.71347 50.6525 5.98874 54.0943 5.98874C55.6893 5.98874 57.2004 6.69831 58.2637 8.08906V1.10692H61.8455V20.0382ZM58.2637 15.6105V10.757C57.6481 9.84878 56.3889 9.19598 55.1856 9.19598C53.1709 9.19598 51.7718 10.8138 51.7718 13.1979C51.7718 15.5537 53.1709 17.1715 55.1856 17.1715C56.3889 17.1715 57.6481 16.5187 58.2637 15.6105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVividLogo);
export default __webpack_public_path__ + "static/media/vivid_logo.a3496edddf663e9a6f232974415ba60a.svg";
export { ForwardRef as ReactComponent };